module.exports = __webpack_public_path__ + "static/rps.vinod.logo.80e1e369.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/partners/rps.vinod.logo.png
// module id = 510
// module chunks = 79718873386587